import { useState } from "react";
import { PenLine, Check, X } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const ReflectionPrompt = ({ session, onDone }) => {
  const [text, setText] = useState("");
  const [saving, setSaving] = useState(false);
  if (!session) return null;

  const save = async (e) => {
    e.preventDefault();
    if (!text.trim()) { onDone(); return; }
    setSaving(true);
    try {
      await api.patch(`/practice/${session.id}/reflection`, { reflection: text.trim() });
      toast.success("Reflection saved — only you can see it");
      onDone();
    } catch (err) { toast.error(errorMessage(err)); } finally { setSaving(false); }
  };

  return (
    <form onSubmit={save} className="rounded-2xl border border-indigo-100 bg-indigo-50/60 p-4 sm:p-5 space-y-3 animate-in fade-in slide-in-from-bottom-2" data-testid="reflection-prompt">
      <div className="flex items-start gap-3">
        <span className="w-9 h-9 rounded-xl bg-white text-indigo-600 grid place-items-center shrink-0"><PenLine className="w-4 h-4" /></span>
        <div>
          <p className="font-semibold text-slate-900 text-sm">One line on how that felt? <span className="text-slate-500 font-normal">(optional)</span></p>
          <p className="text-xs text-slate-500">Private to you — your therapist never sees reflections.</p>
        </div>
      </div>
      <div className="flex gap-2">
        <Input value={text} onChange={(e) => setText(e.target.value)} maxLength={200} placeholder="e.g. Shoulders dropped by the third round" className="bg-white rounded-xl" data-testid="reflection-input" autoFocus />
        <Button type="submit" disabled={saving} className="rounded-xl" data-testid="reflection-save-button"><Check className="w-4 h-4" /> Save</Button>
        <Button type="button" variant="ghost" onClick={onDone} className="rounded-xl" data-testid="reflection-skip-button"><X className="w-4 h-4" /></Button>
      </div>
    </form>
  );
};
